import { createSlice } from "@reduxjs/toolkit";
import {
  handleEditDamagedQuantity,
  handleAddAttachment,
  handleRemoveAttachment,
  handleReset,
  handleUpdateNavigationBlocking,
  handleUpdatePOBasicData,
  handleUpdateNotes,
  handleUpdateReasonForClaim,
  initialState,
  handleSelectAllPalletItems,
  handleUploadFreightClaimAttachmentsPending,
  handleUploadFreightClaimAttachmentsFulfilled,
  handleUploadFreightClaimAttachmentsRejected,
  handleCreateFreightClaimPoPending,
  handleCreateFreightClaimPoFulfilled,
  handleCreateFreightClaimPoRejected,
  handleGetTransferPOProductsForFcPending,
  handleGetTransferPOProductsForFcFulfilled,
  handleGetTransferPOProductsForFcRejected,
  handleGetStoreCreditDetailsForFcPending,
  handleGetStoreCreditDetailsForFcFulfilled,
  handleGetStoreCreditDetailsForFcRejected
} from "./createFcReducers";
import { resetStore } from "src/store/actions";
import {
  createFreightClaimPO,
  getStoreCreditDetailsForFC,
  getTransferPOProductsForFC,
  uploadFreightClaimAttachments
} from "./createFcAsyncThunks";

const createFreightClaimSlice = createSlice({
  name: "createFreightClaim",
  initialState,
  reducers: {
    handleEditDamagedQuantity,
    handleAddAttachment,
    handleRemoveAttachment,
    handleReset,
    handleUpdateNavigationBlocking,
    handleUpdatePOBasicData,
    handleUpdateNotes,
    handleUpdateReasonForClaim,
    handleSelectAllPalletItems
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, () => {
        return initialState;
      })
      .addCase(
        uploadFreightClaimAttachments.pending,
        handleUploadFreightClaimAttachmentsPending
      )
      .addCase(
        uploadFreightClaimAttachments.fulfilled,
        handleUploadFreightClaimAttachmentsFulfilled
      )
      .addCase(
        uploadFreightClaimAttachments.rejected,
        handleUploadFreightClaimAttachmentsRejected
      )
      .addCase(createFreightClaimPO.pending, handleCreateFreightClaimPoPending)
      .addCase(
        createFreightClaimPO.fulfilled,
        handleCreateFreightClaimPoFulfilled
      )
      .addCase(
        createFreightClaimPO.rejected,
        handleCreateFreightClaimPoRejected
      )
      .addCase(
        getTransferPOProductsForFC.pending,
        handleGetTransferPOProductsForFcPending
      )
      .addCase(
        getTransferPOProductsForFC.fulfilled,
        handleGetTransferPOProductsForFcFulfilled
      )
      .addCase(
        getTransferPOProductsForFC.rejected,
        handleGetTransferPOProductsForFcRejected
      )
      .addCase(
        getStoreCreditDetailsForFC.pending,
        handleGetStoreCreditDetailsForFcPending
      )
      .addCase(
        getStoreCreditDetailsForFC.fulfilled,
        handleGetStoreCreditDetailsForFcFulfilled
      )
      .addCase(
        getStoreCreditDetailsForFC.rejected,
        handleGetStoreCreditDetailsForFcRejected
      );
  }
});

export const {
  handleEditDamagedQuantity: editDamagedQuantity,
  handleAddAttachment: addAttachment,
  handleRemoveAttachment: removeAttachment,
  handleReset: reset,
  handleUpdateNavigationBlocking: updateNavigationBlocking,
  handleUpdatePOBasicData: updatePOBasicData,
  handleUpdateNotes: updateNotes,
  handleUpdateReasonForClaim: updateReasonForClaim,
  handleSelectAllPalletItems: selectAllPalletItems
} = createFreightClaimSlice.actions;

export default createFreightClaimSlice.reducer;
